import React, { Fragment, ReactNode } from "react";
import { AppState } from "../../store";
import { SystemState } from "../../store/system/types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

let href: string, content: string, title: string;
let allowedscripts: ReactNode[] = [];

switch (process.env.REACT_APP_CODE_TENANT) {
  case "TBC":
    href = "/favicon/faviconTBC.ico";
    content = "TBC";
    title = "TheBlueCoding"
    break; 
  default:
    href = "/favicon/favicondefault.ico"; // Default fallback
    content = "TBC";
    title = "TheBlueCoding";
}

const HelmetIndex: React.FC<SystemState> = (props: SystemState) => {
  return (
    <Fragment>
      <Helmet>
        <title>{title}</title>
        <link rel="icon" href={href} type="image/x-icon" />
        <meta name="description" content={content} />
        {allowedscripts.map((item) => item)}
      </Helmet>
    </Fragment>
  );
};

const mapStateToProps = (state: AppState) => ({
  ...state.system,
});

export default connect(mapStateToProps)(HelmetIndex);
